import { CodeWindow, Typography } from "@beamcloud/design-system";
import styled from "styled-components";
import { typography } from "../../../components/typography";

export const ContentH1 = styled(Typography).attrs({
  tag: "h1",
  variant: "title4Xl",
  color: "gray12"
})`
  && {
    padding: 24px 0px 8px;
  }
`;

export const ContentH2 = styled(Typography).attrs({
  tag: "h2",
  variant: "title3Xl",
  color: "gray100"
})`
  && {
    ${typography.title28}
    color: ${props => props.theme.colors.gray12};
    margin-bottom: 12px;
    margin-top: 24px;
  }
`;

export const ContentH3 = styled(Typography).attrs({
  tag: "h3",
  variant: "title2Xl",
  color: "gray100"
})`
  && {
    padding: 16px 0px 4px;
  }
`;

export const ContentH4 = styled(Typography).attrs({
  tag: "h4",
  variant: "titleXl",
  color: "gray100"
})`
  && {
    padding: 12px 0px 4px;
  }
`;

export const ContentNormal = styled(Typography).attrs({
  tag: "p",
  variant: "textLg",
  color: "gray300"
})``;

export const ContentBlockQuote = styled(Typography).attrs({
  tag: "blockquote",
  variant: "headingXl",
  color: "gray100"
})`
  && {
    padding: 12px 24px;
    margin: 24px 0;
    border-left: 2px solid ${props => props.theme.colors.gray600};
  }
`;

export const ContentUnorderdList = styled(Typography).attrs({
  tag: "ul",
  variant: "textLg",
  color: "gray300"
})`
  && {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding-inline-start: 30px;
  }
`;

export const ContentOrderedList = styled(Typography).attrs({
  tag: "ol",
  variant: "textLg",
  color: "gray300"
})`
  && {
    display: flex;
    list-style-type: decimal;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding-inline-start: 30px;
  }
`;

export const ContentImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px 0;
  padding: 24px;
  gap: 10px;
  background: ${props => props.theme.colors.gray850};
  border: 1px solid ${props => props.theme.colors.gray7};
  border-radius: 8px;
`;

export const ContentImage = styled.img`
  width: 100%;
`;

export const ContentCode = styled(CodeWindow)`
  && {
    margin: 16px 0;
    width: 100%;
    background-color: ${props => props.theme.colors.gray850};
  }
`;

export const ContentLink = styled.a`
  color: ${props => props.theme.colors.blue400};
`;

export const ContentInlineCode = styled.code`
  padding: 2px 6px;
  border-radius: 6px;
  background-color: ${props => props.theme.colors.gray700};
`;

export const TestimonialBlockQuote = styled.div`
  && {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 24px;
    border-left: 2px solid ${props => props.theme.colors.white};
    margin-top: 32px;
    margin-bottom: 32px;
    margin-right: 32px;
  }
`;

export const Testimonial = styled.p`
  ${typography.title20}
  color: ${props => props.theme.colors.gray100};
  margin-bottom: 16px;
  margin-top: 0px;
  max-width: 544px;
`;

export const TestimonialName = styled(Typography).attrs({
  tag: "p",
  variant: "textBase",
  color: "gray12"
})`
  && {
    font-weight: 400;
    margin-bottom: 2px;
  }
`;

export const TestimonialPosition = styled(Typography).attrs({
  tag: "p",
  variant: "textBase",
  color: "gray11"
})`
  && {
    font-weight: 400;
  }
`;
